import {
  Backdrop,
  Box,
  CircularProgress,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Typography,
  Pagination,
  Stack,
  TextField,
  Button,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useSelector } from "react-redux";
import productService from "../../../../services/productService";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import useAlert from "../../../../hooks/useAlert";
import { Place } from "@mui/icons-material";
import PropTypes from "prop-types";

const ProductMatchingModal = ({
  open,
  handleClose,
  product,
  pleaces,
  setAllProduct,
}) => {
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const getProduct = async (currentPage) => {
    try {
      setLoading(true);
      var response = await productService.fetchMatchingProducts(
        null,
        userId,
        currentPage,
        pageSize,
        searchTerm
      );
      setProducts(response?.data?.data);

      setTotalPages(Math.ceil(response?.data?.recordsTotal / pageSize) || 1);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      setSelectedProducts([]);
      getProduct(page);
    }
  }, [open, page, searchTerm, pageSize]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearch = () => {
    setSearchTerm(search);
    setPage(1);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: "90%", md: "80%" },
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { xs: 2, sm: 3, md: 4 },
    maxHeight: { xs: "90vh", sm: "80vh" },
    overflow: "auto",
    borderRadius: 2,
  };

  const { showSuccessAlertMarketpleaceBrand, showErrorAlertMarketpleaceBrand } =
    useAlert();
  const saveMatchingProduct = async (selectedProduct) => {
    try {
      setLoading(true);
      var barcode = selectedProduct.productBarcodes
        .map((barcode) => {
          if (
            (barcode.marketPlaceId == pleaces.id &&
              pleaces.type == "marketplace") ||
            (barcode.ecommercePlaceId == pleaces.id &&
              pleaces.type != "marketplace")
          ) {
            return barcode;
          }
        })
        .filter((barcode) => barcode !== undefined);
      if (barcode[0].barcode != null) {
        barcode[0].barcode = product.barcode;
        await productService.updateProductBarcode(barcode[0]);
      } else {
        const barcodeRequest = {
          barcode: product.barcode,
          marketPlaceId: pleaces.type == "marketplace" ? pleaces.id : null,
          ecommercePlaceId: pleaces.type != "marketplace" ? pleaces.id : null,
          productId: selectedProduct.id,
        };
        await productService.addProductBarcode(barcodeRequest);
      }

      var price = selectedProduct.productPrices
        .map((p) => {
          if (
            (p.marketPlaceId == pleaces.id && pleaces.type == "marketplace") ||
            (p.ecommercePlaceId == pleaces.id && pleaces.type != "marketplace")
          ) {
            return p;
          }
        })
        .filter((price) => price !== undefined);
      if (price[0].listPrice != null) {
        price[0].listPrice = product.listPrice;
        price[0].salePrice = product.salePrice;
        await productService.updateProductPrice(price[0]);
      } else {
        const priceRequest = {
          listPrice: product.listPrice,
          salePrice: product.salePrice,
          marketPlaceId: pleaces.type == "marketplace" ? pleaces.id : null,
          ecommercePlaceId: pleaces.type != "marketplace" ? pleaces.id : null,
          productId: selectedProduct.id,
        };

        await productService.addProductPrice(priceRequest);
      }

      if (selectedProduct.productPlaces.length > 0) {
        var place = selectedProduct.productPlaces
          .map((pl) => {
            if (
              (pl.marketPlaceId == pleaces.id &&
                pleaces.type == "marketplace") ||
              (pl.ecommercePlaceId == pleaces.id &&
                pleaces.type != "marketplace")
            ) {
              return pl;
            }
          })
          .filter((place) => place !== undefined);

        if (place.length == 0) {
          const pleacesRequest = {
            marketPlaceId: pleaces.type == "marketplace" ? pleaces.id : null,
            ecommercePlaceId: pleaces.type != "marketplace" ? pleaces.id : null,
            productId: selectedProduct.id,
            ecommerceProductId:product.ecommerceProductId
          };
          await productService.addPlaces(pleacesRequest);
        }
      }

      setAllProduct(product);
      showSuccessAlertMarketpleaceBrand();
      setLoading(false);
    } catch {
      setLoading(false);
      showErrorAlertMarketpleaceBrand();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="category-product-modal"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontSize: { xs: "1.1rem", sm: "1.25rem" },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            Eşleşecek ürünü seçin
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            mb: 2,
            alignItems: { xs: "stretch", sm: "center" },
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Ürün ara..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyPress={handleKeyPress}
          />

          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Select
              size="small"
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
              sx={{
                minWidth: { xs: "100%", sm: "90px" },
                maxWidth: { xs: "100%", sm: "90px" },
              }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>

            <Button
              variant="contained"
              startIcon={<SearchIcon />}
              onClick={handleSearch}
              sx={{
                minWidth: { xs: "100%", sm: "120px" },
                borderRadius: 2,
                whiteSpace: "nowrap",
              }}
            >
              Ara
            </Button>
          </Box>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                "& .MuiTableCell-root": {
                  whiteSpace: "nowrap",
                  [theme.breakpoints.down("sm")]: {
                    padding: "8px 4px",
                    fontSize: "0.75rem",
                  },
                },
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Başlık</TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", md: "table-cell" } }}
                    >
                      Stok Kodu
                    </TableCell>
                    <TableCell>Miktar</TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", lg: "table-cell" } }}
                    >
                      Tedarikçi Barkodu
                    </TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", lg: "table-cell" } }}
                    >
                      Özellikler
                    </TableCell>
                    <TableCell padding="checkbox"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {products?.map((product) => (
                    <TableRow key={product.id}>
                      <TableCell>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={2}
                          sx={{
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: { xs: "flex-start", sm: "center" },
                            gap: { xs: 1, sm: 2 },
                          }}
                        >
                          {product.productImages.length > 0 && (
                            <Box
                              component="img"
                              src={product?.productImages[0]?.imageUrl}
                              alt={product?.title}
                              sx={{
                                width: { xs: 40, sm: 50 },
                                height: { xs: 40, sm: 50 },
                                objectFit: "contain",
                              }}
                            />
                          )}
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                fontWeight: "medium",
                              }}
                            >
                              {product?.title || "-"}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                display: { xs: "block", md: "none" },
                                color: "text.secondary",
                              }}
                            >
                              Stok Kodu: {product.stockCode}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                display: { xs: "block", lg: "none" },
                                color: "text.secondary",
                              }}
                            >
                              Tedarikçi: {product.supplierBarcode}
                            </Typography>
                          </Box>
                        </Stack>
                      </TableCell>
                      <TableCell
                        sx={{ display: { xs: "none", md: "table-cell" } }}
                      >
                        {product.stockCode}
                      </TableCell>
                      <TableCell>{product.quantity}</TableCell>
                      <TableCell
                        sx={{ display: { xs: "none", lg: "table-cell" } }}
                      >
                        {product.supplierBarcode}
                      </TableCell>
                      <TableCell
                        sx={{ display: { xs: "none", lg: "table-cell" } }}
                      >
                        {product.productAttributes &&
                        product.productAttributes.length > 0 ? (
                          <Box sx={{ maxWidth: "200px" }}>
                            {product.productAttributes.map((attr, index) => (
                              <Typography
                                key={index}
                                variant="caption"
                                display="block"
                                sx={{
                                  fontSize: "0.75rem",
                                  whiteSpace: "normal",
                                }}
                              >
                                {attr.attributeValue.attribute.name}:{" "}
                                {attr.attributeValue?.name}
                              </Typography>
                            ))}
                          </Box>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell padding="checkbox">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => saveMatchingProduct(product)}
                          sx={{
                            minWidth: { xs: "100%", sm: "90px" },
                            fontSize: { xs: "0.7rem", sm: "0.75rem" },
                            borderRadius: 2,
                            mx: { xs: 0, sm: 2 },
                            whiteSpace: "nowrap",
                          }}
                        >
                          Seç
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 0 },
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
                siblingCount={isMobile ? 0 : 1}
                boundaryCount={isMobile ? 0 : 1}
                size={isMobile ? "small" : "large"}
                sx={{
                  "& .MuiPagination-ul": {
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: 1,
                  },
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

ProductMatchingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  product: PropTypes.shape({
    id: PropTypes.number,
    barcode: PropTypes.string,
    listPrice: PropTypes.number,
    salePrice: PropTypes.number,
    title: PropTypes.string,
    stockCode: PropTypes.string,
    supplierBarcode: PropTypes.string,
    quantity: PropTypes.number,
    productImages: PropTypes.arrayOf(
      PropTypes.shape({
        imageUrl: PropTypes.string,
      })
    ),
    productAttributes: PropTypes.arrayOf(
      PropTypes.shape({
        attributeValue: PropTypes.shape({
          name: PropTypes.string,
          attribute: PropTypes.shape({
            name: PropTypes.string,
          }),
        }),
      })
    ),
  }).isRequired,
  pleaces: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(["marketplace", "ecommerce"]).isRequired,
  }).isRequired,
  setAllProduct: PropTypes.func.isRequired,
};

export default ProductMatchingModal;
